import { render } from "./AppNavigationItem.vue?vue&type=template&id=25cd7452&scoped=true"
import script from "./AppNavigationItem.vue?vue&type=script&lang=js"
export * from "./AppNavigationItem.vue?vue&type=script&lang=js"

import "./AppNavigationItem.vue?vue&type=style&index=0&id=25cd7452&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25cd7452"]])

export default __exports__